import * as React from "react";
import axios from "axios";

export interface IRecentProductsProps {
  className?: string;
}

export const RecentProducts: React.FunctionComponent<IRecentProductsProps> = props => {
  const { className } = props;
  const [products, setProducts] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const loadProducts = async () => {
      try {
        const result = await axios.get("/sfapi/products-ms", {
          params: {
            $limit: 4,
            $sort: {
              updatedAt: -1
            }
          }
        });

        if (result && result.data) {
          setProducts(result.data.data || []);
        }
      } catch (error) {
        console.error("Failed to load recent products:", error);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, []);

  if (loading) {
    return (
      <div className="relative mt-8">
        <div className="relative w-full overflow-x-auto">
          <ul
            role="list"
            className="mx-4 inline-flex space-x-8 sm:mx-6 lg:mx-0 lg:grid lg:grid-cols-4 lg:gap-x-8 lg:space-x-0"
          >
            {[1, 2, 3, 4].map(i => (
              <li
                key={i}
                className="inline-flex w-64 flex-col text-center lg:w-auto"
              >
                <div className="aspect-square w-full rounded-md bg-gray-200 animate-pulse"></div>
                <div className="mt-6 space-y-2">
                  <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                  <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto animate-pulse"></div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }

  return (
    <div className="relative mt-8">
      <div className="relative w-full overflow-x-auto">
        <ul
          role="list"
          className="mx-4 inline-flex space-x-8 sm:mx-6 lg:mx-0 lg:grid lg:grid-cols-4 lg:gap-x-8 lg:space-x-0"
        >
          {products.map(product => {
            const hasImages =
              product.product &&
              product.product.images &&
              product.product.images.length > 0;
            const imageUrl =
              hasImages && product.product.images[0].url
                ? `https://storage.googleapis.com/icstorage/${product.product.images[0].url}`
                : "https://via.placeholder.com/400";
            const price = product.price != null ? product.price : null;

            return (
              <li
                key={product._id}
                className="inline-flex w-64 flex-col text-center lg:w-auto"
              >
                <div className="group relative">
                  <img
                    src={imageUrl}
                    alt={product.name}
                    className="aspect-square w-full rounded-md bg-gray-200 object-cover group-hover:opacity-75"
                  />
                  <div className="mt-6">
                    <p className="text-sm text-gray-500">{product.key}</p>
                    <h3 className="mt-1 font-semibold text-gray-900">
                      <a href={`/product/${product.key}`}>
                        <span className="absolute inset-0"></span>
                        {product.name}
                      </a>
                    </h3>
                    {price !== null && (
                      <p className="mt-1 text-gray-900">${price.toFixed(2)}</p>
                    )}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default RecentProducts;
